import ReactGA from 'react-ga4';
import { devLog } from '.';
import Mixpanel from '../lib/mixpanel';

/**
 * @deprecated use trackDetailedEvent to track both mixpanel and GA
 */
export const trackEvent = (eventName) => {
  // Don't track in dev mode
  if (!import.meta.env.NODE_ENV || import.meta.env.NODE_ENV !== 'production') {
    if (import.meta.env.VITE_LOG_TRACKING_EVENTS === true) {
      devLog('tracking', '- NOT tracked', eventName);
    }
    return;
  }

  // Send tracking events
  if (import.meta.env.VITE_LOG_TRACKING_EVENTS === true) {
    devLog('tracking', 'tracked', eventName);
  }
  ReactGA.event(eventName);
};

/**
 * Track with mixpanel and GA
 * @param eventName
 * @param properties
 */
export const trackDetailedEvent = (eventName, properties = {}) => {
  Mixpanel.track(eventName, properties);
  trackEvent(eventName);
};
